import {
    WHATSAPP_LISTLOADING,
    WHATSAPP_LIST,
    
    WHATSAPP_VENDEDOR_LISTLOADING,
    WHATSAPP_VENDEDOR_LIST,

    WHATSAPP_CONTATOPARC_LISTLOADING,
    WHATSAPP_CONTATOPARC_LIST,

    WHATSAPP_CONTATOPARC_UPDATE,
    WHATSAPP_CONTATOPARC_UPDATELOADING,

    WHATSAPP_CONTATOPARC_INSERT,
    WHATSAPP_CONTATOPARC_INSERTLOADING,

    WHATSAPP_GET_VENDEDORES_RELATORIO,
    WHATSAPP_GET_VENDEDORES_RELATORIOLOADING,

    SET_VENDEDOR_FILTRO,

    // WHATSAPP_SALVA_PAGINATION


} from '../actions/ActionsTypes';

import * as Api from '../utils/API';




export const WhatsappListAction = (codvend, codparc) => (dispatch) =>
    new Promise(function (resolve, reject) {
        console.log("codvend enviado para API:", codvend, codparc);
        dispatch({ type: WHATSAPP_LISTLOADING, payload: true })
        Api.getParceirosLista(codvend, codparc).then(dados => {
            dispatch({ type: WHATSAPP_LIST, payload: dados })
            dispatch({ type: WHATSAPP_LISTLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });


export const WhatsappVendedoresListAction = (userid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: WHATSAPP_VENDEDOR_LISTLOADING, payload: true })
        Api.getVendedorLista(userid).then(dados => {
            dispatch({ type: WHATSAPP_VENDEDOR_LIST, payload: dados })
            dispatch({ type: WHATSAPP_VENDEDOR_LISTLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });


export const WhatsappContatoParcListAction = (codparc) => (dispatch) =>
    new Promise(function (resolve, reject) {
        console.log("codvend enviado para API:", codparc);
        dispatch({ type: WHATSAPP_CONTATOPARC_LISTLOADING, payload: true })
        Api.getContatosParceirosLista(codparc).then(dados => {
            dispatch({ type: WHATSAPP_CONTATOPARC_LIST, payload: dados })
            dispatch({ type: WHATSAPP_CONTATOPARC_LISTLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const WhatsappUpdateContatoParcAction = (codparc, ad_whatsappcp, email, nomecontato, nunota, isprincipal, iscomercial, iscentregas, isnfe, codusu, dtfim, codcontato) => (dispatch) =>
new Promise(function (resolve, reject) {
    //console.log("codvend enviado para API:", codparc);
    console.log(codparc, ad_whatsappcp, email, nomecontato, nunota, isprincipal, iscomercial, iscentregas, isnfe, codusu, dtfim, codcontato);
    
    dispatch({ type: WHATSAPP_CONTATOPARC_UPDATELOADING, payload: true })
    Api.updateContatosParceiros(codparc, ad_whatsappcp, email, nomecontato, nunota, isprincipal, iscomercial, iscentregas, isnfe, codusu, dtfim, codcontato).then(dados => {
        dispatch({ type: WHATSAPP_CONTATOPARC_UPDATE, payload: dados })
        dispatch({ type: WHATSAPP_CONTATOPARC_UPDATELOADING, payload: false })
        resolve([])
    }).catch(error => {
        reject(error);
    })
});

export const WhatsappInsertContatoParcAction = (codparc, nomecontato, ad_whatsappcp, email, nunota, isprincipal, iscomercial, iscentregas, isnfe, codusu) => (dispatch) =>
new Promise(function (resolve, reject) {
   // console.log("codvend enviado para API:", codparc);
    dispatch({ type: WHATSAPP_CONTATOPARC_INSERTLOADING, payload: true })
    Api.insertContatosParceiros(codparc, ad_whatsappcp, email, nomecontato, nunota, isprincipal, iscomercial, iscentregas, isnfe, codusu).then(dados => {
        dispatch({ type: WHATSAPP_CONTATOPARC_INSERT, payload: dados })
        dispatch({ type: WHATSAPP_CONTATOPARC_INSERTLOADING, payload: false })
        resolve([])
    }).catch(error => {
        reject(error);
    })
});

export const GetVendedoresRelatorioAction = (entidade) => (dispatch) =>
new Promise(function (resolve, reject) {
   // console.log("codvend enviado para API:", codparc);
    dispatch({ type: WHATSAPP_GET_VENDEDORES_RELATORIOLOADING, payload: true })
    Api.getVendedoresRelatorio(entidade).then(dados => {
        dispatch({ type: WHATSAPP_GET_VENDEDORES_RELATORIO, payload: dados })
        dispatch({ type: WHATSAPP_GET_VENDEDORES_RELATORIOLOADING, payload: false })
        resolve([])
    }).catch(error => {
        reject(error);
    })
});

export const clearParceiros = () => (dispatch) => {
    dispatch({ type: 'WHATSAPP_CLEAR_PARCEIROS' });
};

export const setVendedorFiltro = (codvend) => ({
    type: 'SET_VENDEDOR_FILTRO',
    payload: codvend
});


//atualizar temporariamente as quantidades do parceiro no estado local para refletir as mudanças imediatamente na interface, sem precisar esperar a resposta da API
export const atualizarQuantidadesParceiroLocal = (codparc, novasQuantidades) => ({
  type: 'ATUALIZAR_QUANTIDADES_PARCEIRO_LOCAL',
  payload: { codparc, novasQuantidades }
});


// export const WhatsappSalvaPagination = (page, total) => ({
//    type: 'WHATSAPP_SALVA_PAGINATION',
//    payload: { page, total }
// });

